<template>
  <!-- 尾部 -->
  <footer class="footer min_width">
    <div class="page_center">
      <div class="com_box">
        
        <span>地址：深圳市罗湖区东门街道湖贝社区文锦中路1043号联兴大厦中座3层302</span>
        <span>网站备案：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">粤ICP备2024255116号</a></span>
      </div>
      <div class="info">“心荐”即用心举荐，诚心举荐。“心荐”诚邀天下客，欢迎各方共参、共建、共享</div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.footer {
  background-color: transparent;
  height: 80px;
  // padding: 5px 0 45px 0;
  width: 100%;
  .page_center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .com_box{
      padding: 10px;
      span{
        margin: 0 10px;
        font-size: 12px;
        color: #333333;
      }
    }
    .info{
        font-size: 12px;
        color: rgba($color: #333333, $alpha:0.5);
    }
  }
}

</style>
